<template>
  <div class="insert-page">
    <div class="insert-page-list">
      <div class="insert-page-item" v-for="(page, index) in insertPages" :key="index"
           :class="{ selected: insert === page.name }"
           @click="$emit('change', page.name)">
        <p class="insert-page-label">{{page.label}}</p>
        <div class="insert-page-preview">
          <button class="insert-page-nav insert-page-nav--prev"
                  @click.stop="prevMonth(index)">
            <i class="fa fa-chevron-left"></i>
          </button>
          <div class="insert-page-img">
            <cover-holder :src="getMonthImage(page.name, months[index])" :height="coverHeight"
                          :selected="insert === page.name" />
          </div>
          <button class="insert-page-nav insert-page-nav--next"
                  @click.stop="nextMonth(index)">
            <i class="fa fa-chevron-right"></i>
          </button>
        </div>
        <p class="insert-page-month">{{monthLabel(months[index])}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import CoverHolder from '../../../components/CoverHolder'
export default {
  props: {
    insert: {
      type: String,
      default: 'simple'
    }
  },
  components: { CoverHolder },
  data: () => ({
    coverHeight: 141.1,
    months: [1, 1]
  }),
  computed: {
    insertPages () {
      return [
        {
          name: 'simple',
          label: this.$t('cover.insertSimple')
        },
        {
          name: 'child',
          label: this.$t('cover.insertChild')
        }
      ]
    },
    year () {
      return (new Date()).getFullYear()
    }
  },
  methods: {
    getMonthImage (name, month) {
      const codeName = name === 'simple' ? 'en' : 'child'
      return `https://canvas.xinshu.me/generate/insert-${codeName}?year=${this.year}&month=${month}`
    },
    monthLabel (month) {
      const names = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      return names[month - 1]
    },
    prevMonth (index) {
      const m = this.months[index]
      this.$set(this.months, index, m <= 1 ? 12 : m - 1)
    },
    nextMonth (index) {
      const m = this.months[index]
      this.$set(this.months, index, m >= 12 ? 1 : m + 1)
    }
  }
}
</script>

<style lang="scss">
.insert-page {
  &-list {
    display: flex;
    gap: 16px;
  }
  &-item {
    flex: 0 0 40%;
    cursor: pointer;
    text-align: center;
    border: 2px solid transparent;
    border-radius: 8px;
    padding: 12px 8px;
    transition: border-color 0.2s, background 0.2s;

    &:hover { background: #f9f9f9; }
    &.selected {
      border-color: #F56368;
      background: rgba(81, 45, 202, 0.03);
    }
  }
  &-label {
    font-size: 13px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }
  &-preview {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  &-img {
    flex: 1;
    min-width: 0;
  }
  &-nav {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid #ddd;
    background: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: #999;
    font-size: 11px;
    transition: all 0.2s;

    &:hover {
      border-color: #F56368;
      color: #F56368;
      background: rgba(81, 45, 202, 0.05);
    }
  }
  &-month {
    font-size: 12px;
    color: #999;
    margin-top: 6px;
  }
}

.ce-mobile .insert-page-list {
  flex-wrap: wrap;
}
.ce-mobile .insert-page-item {
  flex: 0 0 100%;
}
</style>
